// Per-dog vet & specialist contact cards. Backed by /dogs/{id}/vet-contacts
// and rendered through the reusable ContactCardsSection.
import ContactCardsSection from "@/components/app/ContactCardsSection";
import { Stethoscope } from "lucide-react";

const FIELDS = [
  { key: "name",      label: "Name",              placeholder: "e.g. Dr. Alicia Fernández", maxLength: 80 },
  { key: "role",      label: "Role / specialty",  placeholder: "Primary vet · Cardiology · ER" },
  { key: "practice",  label: "Practice / clinic", placeholder: "Ridge Veterinary Hospital" },
  { key: "phone",     label: "Phone",             placeholder: "555-1234", type: "tel" },
  { key: "email",     label: "Email",             placeholder: "front-desk@ridgevet.com", type: "email" },
  { key: "address",   label: "Address",           placeholder: "112 Ridge Rd · Springfield", wide: true },
  { key: "hours",     label: "Hours / availability", placeholder: "Mon–Fri 8–6, Sat 9–1 · 24/7 on-call", wide: true },
  { key: "emergency", label: "Emergency contact — surface this at the top of the list", type: "checkbox", wide: true },
  { key: "notes",     label: "Notes",             placeholder: "Preferred protocols, allergies flagged, vaccine cadence…", type: "textarea", wide: true },
];

export default function VetContactsCard({ dogId }) {
  return (
    <ContactCardsSection
      dogId={dogId}
      path="vet-contacts"
      singular="contact"
      plural="vets & specialists"
      Icon={Stethoscope}
      overline="Care team"
      title="Vets & specialists"
      intro="Every professional who cares for your dog — primary vet, ER hospital, cardiologist, rehab specialist, dermatologist."
      fields={FIELDS}
      testidPrefix="vet-contact"
    />
  );
}
